import {withFormsy} from 'formsy-react';
import React from 'react';

class FileButton extends React.Component {

    constructor(props)
    {
        super(props);

        this.state = {
        }
    }

    static defaultProps = {
        accept: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,.txt,.text,image/*',
    };

    onSelectFile = files => {
        if (files && files.length > 0) {
            const file = files[0];
            const lastDot = file.name.lastIndexOf('.');

            const fileName = file.name.substring(0, lastDot);
            const ext = file.name.substring(lastDot + 1);

            // console.log('onSelectFile', {fileName, ext, path: file.path});

            this.props.setValue(file)

        }
    };

    getFileIcon(file) {
        let name = '';
        if (typeof file === 'string') {
            name = file;
        }else if (TB.isObject(file)) {
            name = file?.name || ''
        }
        let lastDot = name.lastIndexOf('.');

        if (lastDot === -1) {
            return 'file-alt';
        }

        let ext = name.substring(lastDot + 1);

        switch (ext) {
            case 'csv':
                return 'file-csv'
            case 'ppt':
            case 'ppxt':
                return 'file-powerpoint'
            case 'xls':
            case 'xlsx':
                return 'file-excel'
            case 'doc':
            case 'docx':
                return 'file-word'
            case 'pdf':
                return 'file-pdf';
            default:
                return 'file-alt';
        }
    }

    getFileName(file) {

        if (this.props.fileNameDisplay) {
            file = this.props.fileNameDisplay() || file
        }

        return TB.isString(file) ? file : (file?.name || 'Document')
    }

    render()
    {
        let {
            getErrorMessage,
            isFormSubmitted,
            showRequired,
            showError,
            label,
            required,
            disabled
        } = this.props;



        let errorClass = isFormSubmitted() &&
        (showRequired() || showError()) ?
            'is-invalid' :
            null;

        let file = this.props.getValue();
        return (
            <div className={`file-upload-btn form-group ${errorClass ? 'text-danger' : ''} ${disabled ? 'disabled' : ''} ${file ? 'hasFile' : ''}`}>


                <label htmlFor={this.props.name} className="btn btn-outline-white">

                    {file ? (
                        <span>
                        <i className="far fa-file-alt"/>
                        <p>{this.getFileName(file)}</p>
                    </span>
                    ) : (
                        <span>
                         <i className="fas fa-file-upload"/>
                        <p>Select a file to upload</p>
                    </span>
                    )}

                    <input name={this.props.name}
                           title=" "
                           type="file"
                           accept={this.props.accept || FileButton.defaultProps.accept}
                           onChange={e => this.onSelectFile(e.target.files)}/>
                </label>



                <div className="invalid-feedback">
                    <div>{getErrorMessage()}</div>
                </div>

            </div>
        )
    }
}


export default withFormsy(FileButton);
